import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-recently-played-game",
    templateUrl: "./recently-played-game.component.html",
    styleUrls: ["./recently-played-game.component.scss"],
    standalone: true,
    imports: [IonicModule]
})
export class RecentlyPlayedGameComponent implements OnInit {
  @Input() gameImg: string;
  @Input() played: number;
  @Input() notif: number;
  @Output() showPopup = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit() {}
}
